module.exports = __webpack_public_path__ + "static/media/Coolmore_white.e132a02a.png";